import { api, config } from '../../../helpers/api';

export async function surveysListRequest(lastId, ended) {
  return await api.get(
    '/survey/',
    config('json', {
      last_id: lastId,
      ended: ended
    })
  );
}
